import React from "react";
import InputLayout from "../Input/InputLayout";
import { getImageURL } from "../../utils/imageUrl";
import { Image } from "primereact/image";
import dummy from "../../assets/images/placeholder-img.png";

export default function CustomViewImage({ image, col }) {
    return (
        <div>
            <InputLayout col={col}>
                <div className="flex flex-column w-full">
                    <label className="mb-2 w-8rem">Before Image</label>
                    <Image
                        src={image ? getImageURL(image) : dummy}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = dummy;
                        }}
                        alt={image}
                        width="90"
                        height="90"
                        preview
                    />
                </div>
            </InputLayout>
        </div>
    );
}
